import React, { useState, useEffect, useRef } from "react";
import { downloadCsv } from "../common/sharedFunctions";
import MaterialTable, { MTableEditRow, MTableEditField } from "material-table";
import { useHistory, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { Image } from "react-native";
import { api } from "common";
import { useTranslation } from "react-i18next";
import moment from "moment/min/moment-with-locales";
import { makeStyles } from "@mui/styles";
import {
  Modal,
  Grid,
  Typography,
  Checkbox,
  Button,
  Input,
} from "@mui/material";
import { colors } from "../components/Theme/WebTheme";
// import Button from "components/CustomButtons/Button.js";
import CancelIcon from "@mui/icons-material/Cancel";
import AlertDialog from "../components/AlertDialog";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import { Autocomplete } from "@mui/material";
import "../styles/style.css";
// import {uploadImage} from "../../"
import * as yup from "yup";
import Loader from "components/Loader";

const useStyles = makeStyles((theme) => ({
  heading: {
    marginBottom: 20,
    height: "10%",
  },
  submit1: {
    marginLeft: 30,
  },
  submit: {
    backgroundColor: "#de7d1e",
  },
  submit5: {
    backgroundColor: "#0c5c6b",
  },
  submit3: {
    width: "100%",
    borderRadius: 3,
    marginTop: 2,
    padding: 4,
  },
  modal: {
    display: "flex",
    padding: theme.spacing(1),
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    width: 500,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: 15,
    alignItems: "center",
    justifyContent: "center",
  },
  submit4: {
    backgroundColor: "red",
    width: "100%",
    borderRadius: 3,
    marginTop: 2,
    padding: 4,
  },
}));

export default function Users() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const {
    addUser,
    editUser,
    deleteUser,
    checkUserExists,
    fetchUsersOnce,
    updateLicenseImage,
    uploadImage,
  } = api;
  const [data, setData] = useState([]);
  const [cars, setCars] = useState({});
  const staticusers = useSelector((state) => state.usersdata.staticusers);
  const cartypes = useSelector((state) => state.cartypes);
  const auth = useSelector((state) => state.auth);
  const settings = useSelector((state) => state.settingsdata.settings);
  const dispatch = useDispatch();
  const loaded = useRef(false);
  const classes = useStyles();
  const rootRef = useRef(null);
  const [role, setRole] = useState(null);
  const [fleetAdmins, setFleetAdmins] = useState([]);
  const [fleetAdminsObj, setFleetAdminsObj] = useState();
  const [addRowModalOpen, setAddRowModalOpen] = useState(false);
  const [newRowData, setNewRowData] = useState({});
  const [editing, setediting] = useState(false);
  const [oldData, setOlddata] = useState("");
  const [loader, setloader] = useState(false);
  const  navigate = useNavigate()

  useEffect(()=>{
  },[])
  const handleAddRow = (newData) => {
    // Perform any necessary validation or data handling here
    // Add the new row to the table data state
    new Promise((resolve, reject) => {
      setloader(true);
      setTimeout(() => {
        checkUserExists(newData).then((res) => {
          if (res.users && res.users.length > 0) {
            alert(t("user_exists"));
            setloader(false);
            reject();
          } else if (!(newData && newData.firstName)) {
            alert(t("proper_input_name"));
            setloader(false);
            reject();
          } else if (res.error) {
            alert(t("email_or_mobile_issue"));
            setloader(false);

            reject();
          } else if (
            settings &&
            settings.license_image_required &&
            (newData.licenseImage === "" || !newData.licenseImage)
          ) {
            alert(t("proper_input_licenseimage"));
            setloader(false);

            reject();
          } else if (
            settings &&
            settings.license_image_required &&
            (newData.licenseImageBack === "" || !newData.licenseImageBack)
          ) {
            alert(t("proper_input_licenseimage"));
            setloader(false);

            reject();
          } else if (
            settings &&
            settings.imageIdApproval &&
            (newData.verifyIdImage === "" || !newData.verifyIdImage)
          ) {
            alert(t("upload_id_details"));
            setloader(false);

            reject();
          } else if (
            settings &&
            settings.imageIdApproval &&
            !newData.verifyId
          ) {
            alert(t("upload_id_details"));
            setloader(false);

            reject();
          } else {
            newData["usertype"] = "driver";
            newData["createdAt"] = new Date().getTime();
            const c = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            const reference = [...Array(5)]
              .map((_) => c[~~(Math.random() * c.length)])
              .join("");
            newData["referralId"] = reference;
            let role = auth.profile.usertype;
            if (role === "fleetadmin") {
              newData["fleetadmin"] = auth.profile.uid;
            }
            dispatch(addUser(newData));
            dispatch(fetchUsersOnce());
            // navigate('/cars?assigncar=true')
            setloader(false);

            resolve();
          }
        });
      }, 600);
    });
  };
  const hadnleUpdateRow = (newData, oldData) => {
    new Promise((resolve, reject) => {
      setLoading(true);
      setloader(true);

      setTimeout(() => {
        if (!(newData && newData.firstName)) {
          alert(t("proper_input_name"));
          setloader(false);

          reject();
          // } else if (
          //   settings &&
          //   settings.license_image_required &&
          //   !(newData && newData.licenseImage)
          // ) {
          //   alert(t("proper_input_licenseimage"));
          //   reject();
          // } else if (
          //   settings &&
          //   settings.imageIdApproval &&
          //   (newData.verifyIdImage === "" || !newData.verifyIdImage)
          // ) {
          //   alert(t("upload_id_details"));
          //   reject();
          // } else if (settings && settings.imageIdApproval && !newData.verifyId) {
          //   alert(t("upload_id_details"));
          //   reject();
        } else {
          resolve();
          if (newData !== oldData) {
            delete newData.tableData;
            dispatch(editUser(oldData.id, newData));
            setTimeout(() => {
              setLoading(false);
              setloader(false);
              dispatch(fetchUsersOnce());
            }, 10000);
            // updateData();
          }
        }
      }, 600);
    });
  };
  const handleOpenAddRowModal = (data) => {
    setAddRowModalOpen(true);
  };

  const handleCloseAddRowModal = () => {
    setAddRowModalOpen(false);
    setNewRowData({});
  };
  useEffect(() => {
    dispatch(fetchUsersOnce());
  }, [dispatch, fetchUsersOnce]);

  useEffect(() => {
    if (staticusers) {
      if (role === "admin") {
        let arr = staticusers.filter((user) => user.usertype === "fleetadmin");
        let obj = {};
        let arr2 = [];
        for (let i = 0; i < arr.length; i++) {
          let user = arr[i];
          arr2.push({
            id: user.id,
            desc:
              user.firstName +
              " " +
              user.lastName +
              " (" +
              (settings.AllowCriticalEditsAdmin ? user.mobile : "Hidden") +
              ") " +
              (settings.AllowCriticalEditsAdmin ? user.email : "Hidden"),
          });
          obj[user.id] =
            user.firstName +
            " " +
            user.lastName +
            " (" +
            (settings.AllowCriticalEditsAdmin ? user.mobile : "Hidden") +
            ") " +
            (settings.AllowCriticalEditsAdmin ? user.email : "Hidden");
        }
        setFleetAdmins(arr2);
        setFleetAdminsObj(obj);
      }
      setTimeout(() => {
        setData(
          staticusers.filter(
            (user) =>
              user.usertype === "driver" &&
              ((user.fleetadmin === auth.profile.uid &&
                auth.profile.usertype === "fleetadmin") ||
                auth.profile.usertype === "admin")
          )
        );
      }, 1000);
    } else {
      setData([]);
    }
    loaded.current = true;
  }, [
    staticusers,
    auth.profile.usertype,
    auth.profile.uid,
    settings.AllowCriticalEditsAdmin,
    role,
  ]);

  const updateData = () => {
    if (staticusers) {
      if (role === "admin") {
        let arr = staticusers.filter((user) => user.usertype === "fleetadmin");
        let obj = {};
        let arr2 = [];
        for (let i = 0; i < arr.length; i++) {
          let user = arr[i];
          arr2.push({
            id: user.id,
            desc:
              user.firstName +
              " " +
              user.lastName +
              " (" +
              (settings.AllowCriticalEditsAdmin ? user.mobile : "Hidden") +
              ") " +
              (settings.AllowCriticalEditsAdmin ? user.email : "Hidden"),
          });
          obj[user.id] =
            user.firstName +
            " " +
            user.lastName +
            " (" +
            (settings.AllowCriticalEditsAdmin ? user.mobile : "Hidden") +
            ") " +
            (settings.AllowCriticalEditsAdmin ? user.email : "Hidden");
        }
        setFleetAdmins(arr2);
        setFleetAdminsObj(obj);
      }
      setTimeout(() => {
        setData(
          staticusers.filter(
            (user) =>
              user.usertype === "driver" &&
              ((user.fleetadmin === auth.profile.uid &&
                auth.profile.usertype === "fleetadmin") ||
                auth.profile.usertype === "admin")
          )
        );
      }, 1000);
    } else {
      setData([]);
    }
    loaded.current = true;
  };
  useEffect(() => {
    if (auth.profile && auth.profile.usertype) {
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  useEffect(() => {
    if (cartypes.cars) {
      let obj = {};
      cartypes.cars.map((car) => (obj[car.name] = car.name));
      setCars(obj);
    }
  }, [cartypes.cars]);

  const [imageType, setImageType] = useState(null);

  const onClick = (rowData, text) => {
    if (text === "licenseImage") {
      setImageType(text);
      setImageData(rowData.licenseImage);
    } else if (text === "licenseImageBack") {
      setImageType(text);
      setImageData(rowData.licenseImageBack);
    } else if (text === "verifyIdImage") {
      setImageType(text);
      setImageData(rowData.verifyIdImage);
    }
    setProfileModal(true);
    setUserData(rowData);
  };

  const columns = [
    {
      title: t("createdAt"),
      field: "createdAt",
      editable: "never",
      defaultSort: "desc",
      render: (rowData) =>
        rowData.createdAt ? moment(rowData.createdAt).format("lll") : null,
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    {
      title: t("first_name"),
      field: "firstName",
      initialEditValue: "",
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    {
      title: t("last_name"),
      field: "lastName",
      initialEditValue: "",
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    {
      title: t("mobile"),
      field: "mobile",
      editable: "onAdd",
      render: (rowData) =>
        settings.AllowCriticalEditsAdmin ? rowData.mobile : "Hidden for Demo",
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    {
      title: t("email"),
      field: "email",
      editable: "onAdd",
      render: (rowData) =>
        settings.AllowCriticalEditsAdmin ? rowData.email : "Hidden for Demo",
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
      headerStyle: { textAlign: "center" },
    },
    {
      title: t("profile_image"),
      field: "profile_image",
      render: (rowData) =>
        rowData.profile_image ? (
          <img
            alt="Profile"
            src={rowData.profile_image}
            style={{ width: 50, borderRadius: "50%" }}
          />
        ) : null,
      editable: "never",
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    // {
    //   title: t("verify_id"),
    //   field: "verifyId",
    //   cellStyle: { textAlign: isRTL === "rtl" ? "center" : "left" },
    // },
    // {
    //   title: t("verifyid_image"),
    //   field: "verifyIdImage",
    //   cellStyle: { textAlign: "center" },
    //   render: (rowData) =>
    //     rowData.verifyIdImage ? (
    //       <Button
    //         onClick={() => {
    //           onClick(rowData, "verifyIdImage");
    //         }}
    //       >
    //         <img
    //           alt="License"
    //           src={rowData.verifyIdImage}
    //           style={{ width: 100 }}
    //         />
    //       </Button>
    //     ) : null,
    // },
    // {
    //   title: t("fleetadmins"),
    //   field: "fleetadmin",
    //   hidden: role === "admin" ? false : true,
    //   editable: role === "admin" ? "always" : "never",
    //   cellStyle: { textAlign: "center" },
    //   render: (rowData) =>
    //     rowData.fleetadmin ? fleetAdminsObj[rowData.fleetadmin] : null,
    //   editComponent: (props) => (
    //     <Autocomplete
    //       id="combo-box-demo"
    //       options={fleetAdmins}
    //       getOptionLabel={(option) => option.desc}
    //       style={{ width: 300 }}
    //       renderInput={(params) => (
    //         <TextField {...params} label="Combo box" variant="outlined" />
    //       )}
    //       onChange={(event, newValue) => {
    //         props.onChange(newValue.id);
    //       }}
    //     />
    //   ),
    // },
    {
      title: t("vehicle_model_name"),
      field: "vehicleMake",
      editable: "never",
      initialEditValue: "",
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    {
      title: t("vehicle_model_no"),
      field: "vehicleModel",
      editable: "never",
      initialEditValue: "",
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    {
      title: t("vehicle_reg_no"),
      field: "vehicleNumber",
      editable: "never",
      initialEditValue: "",
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    {
      title: t("other_info"),
      field: "other_info",
      editable: "never",
      initialEditValue: "",
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    {
      title: t("car_type"),
      field: "carType",
      editable: "never",
      lookup: cars,
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    {
      title: t("car_approval"),
      field: "carApproved",
      editable: "never",
      type: "boolean",
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    {
      title: t("account_approve"),
      field: "approved",
      type: "boolean",
      initialEditValue: true,
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    {
      title: t("driver_active"),
      field: "driverActiveStatus",
      type: "boolean",
      initialEditValue: true,
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    {
      title: t("license_image_front"),
      field: "licenseImage",
      cellStyle: { textAlign: "center" },
      render: (rowData) =>
        rowData.licenseImage ? (
          <Button
            onClick={() => {
              onClick(rowData, "licenseImage");
            }}
          >
            <img
              alt="License"
              src={rowData.licenseImage}
              style={{ width: 100 }}
            />
          </Button>
        ) : null,
    },
    {
      title: t("license_image_back"),
      field: "licenseImageBack",
      cellStyle: { textAlign: "center" },
      render: (rowData) =>
        rowData.licenseImageBack ? (
          <Button
            onClick={() => {
              onClick(rowData, "licenseImageBack");
            }}
          >
            <img
              alt="License"
              src={rowData.licenseImageBack}
              style={{ width: 100 }}
            />
          </Button>
        ) : null,
    },
    {
      title: t("wallet_balance"),
      field: "walletBalance",
      type: "numeric",
      editable: "never",
      initialEditValue: 0,
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    {
      title: t("you_rated_text"),
      render: (rowData) => <span>{rowData.rating ? rowData.rating : "0"}</span>,
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    // {
    //   title: t("signup_via_referral"),
    //   field: "signupViaReferral",
    //   editable: "never",
    //   cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    // },
    // {
    //   title: t("referralId"),
    //   field: "referralId",
    //   editable: "never",
    //   initialEditValue: "",
    //   cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    // },
    {
      title: t("bankName"),
      field: "bankName",
      hidden: settings.bank_fields === false ? true : false,
      initialEditValue: "",
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    {
      title: t("bankCode"),
      field: "bankCode",
      hidden: settings.bank_fields === false ? true : false,
      initialEditValue: "",
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    {
      title: t("bankAccount"),
      field: "bankAccount",
      hidden: settings.bank_fields === false ? true : false,
      initialEditValue: "",
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    {
      title: t("queue"),
      field: "queue",
      type: "boolean",
      initialEditValue: false,
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
  ];

  const [profileModal, setProfileModal] = useState(false);
  const [imageData, setImageData] = useState(false);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const [loading, setLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const handleProfileModal = (e) => {
    setProfileModal(false);
    setSelectedImage(null);
  };


  // useEffect(()=>{
  // },[])
  const [userData, setUserData] = useState();

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };

  const handleSetProfileModal = (e) => {
    e.preventDefault();
    if (selectedImage) {
      setLoading(true);
      dispatch(updateLicenseImage(userData.id, selectedImage, imageType));
      setProfileModal(false);
      setSelectedImage(null);
      setTimeout(() => {
        setLoading(false);
        dispatch(fetchUsersOnce());
      }, 10000);
    } else {
      setCommonAlert({ open: true, msg: t("choose_image_first") });
    }
  };

  const [selectedRow, setSelectedRow] = useState(null);

  return !loaded.current ? (
    <CircularLoading />
  ) : (
    <div style={{ backgroundColor: colors.LandingPage_Background }}>
      <MaterialTable
        //title={t("drivers")}
        title={<span className="tableTitleStyle">{t("drivers")}</span>}
        columns={columns}
        // components={{
        //   // MTableEditField
        //   EditRow: (props) => (
        //     <div
        //       style={{
        //         backgroundColor: "green",
        //         position: "absolute",
        //         width: "70%",
        //         height: 800,
        //       }}
        //     >
        //       <MTableEditRow {...props} />
        //     </div>
        //   ),
        //   EditField: (props) => (
        //     <div
        //       style={{
        //         backgroundColor: "black",
        //         position: "absolute",
        //         width: "70%",
        //         height: 800,
        //         display: "flex",
        //         flexDirection: "column",
        //       }}
        //     >
        //       <MTableEditField {...props} />
        //     </div>
        //   ),
        // }}
        style={{
          direction: isRTL === "rtl" ? "rtl" : "ltr",
          borderRadius: "16px",
          // marginTop: 30,
          boxShadow: "rgba(0, 0, 0, 0.1) 0px -0.4rem 3rem",
        }}
        data={data}
        onRowClick={(evt, selectedRow) =>
          setSelectedRow(selectedRow.tableData.id)
        }
        options={{
          exportCsv: (columns, data) => {
            let hArray = [];
            const headerRow = columns.map((col) => {
              if (typeof col.title === "object") {
                return col.title.props.text;
              }
              hArray.push(col.field);
              return col.title;
            });
            const dataRows = data.map(({ tableData, ...row }) => {
              row.createdAt =
                new Date(row.createdAt).toLocaleDateString() +
                " " +
                new Date(row.createdAt).toLocaleTimeString();
              row.fleetadmin = row.fleetadmin
                ? fleetAdminsObj[row.fleetadmin]
                : "";
              let dArr = [];
              for (let i = 0; i < hArray.length; i++) {
                dArr.push(row[hArray[i]]);
              }
              return Object.values(dArr);
            });
            const { exportDelimiter } = ",";
            const delimiter = exportDelimiter ? exportDelimiter : ",";
            const csvContent = [headerRow, ...dataRows]
              .map((e) => e.join(delimiter))
              .join("\n");
            const csvFileName = "download.csv";
            downloadCsv(csvContent, csvFileName);
          },
          exportButton: {
            csv: settings.AllowCriticalEditsAdmin,
            pdf: false,
          },
          maxColumnSort: "all_columns",
          rowStyle: (rowData) => ({
            fontSize: "12px",
            // backgroundColor:
            //   selectedRow === rowData.tableData.id ? "#EEE" : "#FFF",
          }),
          editable: {
            // backgroundColor: colors.Header_Text,
            fontSize: "12px",
            fontWeight: "bold ",
            //fontFamily: 'Lucida Console", "Courier New", monospace',
          },
          headerStyle: {
            position: "sticky",
            top: "0px",
            //backgroundColor: colors.Header_Text_back,
            backgroundColor: "#e1e7f0",
            color: "#000",
            fontSize: "12px",
            fontWeight: "bold ",
            //fontFamily: 'Lucida Console", "Courier New", monospace',
          },
        }}
        localization={{
          body: {
            addTooltip: t("add"),
            deleteTooltip: t("delete"),
            editTooltip: t("edit"),
            emptyDataSourceMessage: t("blank_message"),
            editRow: {
              deleteText: t("delete_message"),
              cancelTooltip: t("cancel"),
              saveTooltip: t("save"),
            },
          },
          toolbar: {
            searchPlaceholder: t("search"),
            exportTitle: t("export"),
          },
          header: {
            actions: t("actions"),
          },
          pagination: {
            labelDisplayedRows: "{from}-{to} " + t("of") + " {count}",
            firstTooltip: t("first_page_tooltip"),
            previousTooltip: t("previous_page_tooltip"),
            nextTooltip: t("next_page_tooltip"),
            lastTooltip: t("last_page_tooltip"),
          },
        }}
        actions={[
          {
            icon: "edit",
            onClick: (event, rowData) => {
              // Do save operation
              setediting(true);
              setOlddata(rowData);
              handleOpenAddRowModal();
            },
          },
          {
            icon: "add",
            tooltip: "Add Row",
            isFreeAction: true,
            onClick: handleOpenAddRowModal,
          },
        ]}
        editable={{
          // onRowAdd: (newData) =>
          //   new Promise((resolve, reject) => {
          //     setTimeout(() => {
          //       checkUserExists(newData).then((res) => {
          //         if (res.users && res.users.length > 0) {
          //           alert(t("user_exists"));
          //           reject();
          //         } else if (!(newData && newData.firstName)) {
          //           alert(t("proper_input_name"));
          //           reject();
          //         } else if (res.error) {
          //           alert(t("email_or_mobile_issue"));
          //           reject();
          //         } else if (
          //           settings &&
          //           settings.license_image_required &&
          //           (newData.licenseImage === "" || !newData.licenseImage)
          //         ) {
          //           alert(t("proper_input_licenseimage"));
          //           reject();
          //         } else if (
          //           settings &&
          //           settings.license_image_required &&
          //           (newData.licenseImageBack === "" ||
          //             !newData.licenseImageBack)
          //         ) {
          //           alert(t("proper_input_licenseimage"));
          //           reject();
          //         } else if (
          //           settings &&
          //           settings.imageIdApproval &&
          //           (newData.verifyIdImage === "" || !newData.verifyIdImage)
          //         ) {
          //           alert(t("upload_id_details"));
          //           reject();
          //         } else if (
          //           settings &&
          //           settings.imageIdApproval &&
          //           !newData.verifyId
          //         ) {
          //           alert(t("upload_id_details"));
          //           reject();
          //         } else {
          //           newData["usertype"] = "driver";
          //           newData["createdAt"] = new Date().getTime();
          //           const c = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
          //           const reference = [...Array(5)]
          //             .map((_) => c[~~(Math.random() * c.length)])
          //             .join("");
          //           newData["referralId"] = reference;
          //           let role = auth.profile.usertype;
          //           if (role === "fleetadmin") {
          //             newData["fleetadmin"] = auth.profile.uid;
          //           }
          //           dispatch(addUser(newData));
          //           dispatch(fetchUsersOnce());
          //           resolve();
          //         }
          //       });
          //     }, 600);
          //   }),
          // onRowUpdate: (newData, oldData) =>
          //   new Promise((resolve, reject) => {
          //     setTimeout(() => {
          //       if (!(newData && newData.firstName)) {
          //         alert(t("proper_input_name"));
          //         reject();
          //       } else if (
          //         settings &&
          //         settings.license_image_required &&
          //         !(newData && newData.licenseImage)
          //       ) {
          //         alert(t("proper_input_licenseimage"));
          //         reject();
          //       } else if (
          //         settings &&
          //         settings.imageIdApproval &&
          //         (newData.verifyIdImage === "" || !newData.verifyIdImage)
          //       ) {
          //         alert(t("upload_id_details"));
          //         reject();
          //       } else if (
          //         settings &&
          //         settings.imageIdApproval &&
          //         !newData.verifyId
          //       ) {
          //         alert(t("upload_id_details"));
          //         reject();
          //       } else {
          //         resolve();
          //         if (newData !== oldData) {
          //           delete newData.tableData;
          //           dispatch(editUser(oldData.id, newData));
          //           dispatch(fetchUsersOnce());
          //         }
          //       }
          //     }, 600);
          //   }),
          onRowDelete: (oldData) =>
            settings.AllowCriticalEditsAdmin
              ? new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    dispatch(deleteUser(oldData.id));
                    dispatch(fetchUsersOnce());
                  }, 600);
                })
              : new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    alert(t("demo_mode"));
                  }, 600);
                }),
        }}
      />
      {loader ? <Loader /> : null}
      <AddRowModal
        isOpen={addRowModalOpen}
        onClose={handleCloseAddRowModal}
        onAddRow={handleAddRow}
        hadnleUpdateRow={hadnleUpdateRow}
        oldData={oldData}
        editing={editing}
        setediting={setediting}
        setOlddata={setOlddata}
        uploadImage={uploadImage}
        updateLicenseImage={updateLicenseImage}
        dispatch={dispatch}
        setloader={setloader}
        redirectMe={()=>navigate('/cars?assigncar=true')}
      />
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={profileModal}
        onClose={handleProfileModal}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid
          container
          spacing={1}
          className={classes.paper}
          style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography component="h1" variant="h6">
              {t("license_image")}
              <input
                type="file"
                style={{ marginLeft: 10 }}
                name={t("image")}
                onChange={(event) => {
                  setSelectedImage(event.target.files[0]);
                }}
              />
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {selectedImage && !loading ? (
              <Tooltip title={t("cancel")}>
                <CancelIcon
                  onClick={() => setSelectedImage(null)}
                  style={{
                    fontSize: 30,
                    backgroundColor: "red",
                    borderRadius: 50,
                    color: "white",
                  }}
                />
              </Tooltip>
            ) : null}
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {selectedImage ? (
              <img
                alt="not fount"
                height={"200px"}
                src={URL.createObjectURL(selectedImage)}
                style={{ marginTop: 15, marginBottom: 20 }}
              />
            ) : (
              <img
                alt="licimage"
                height={"200px"}
                src={imageData}
                style={{ marginTop: 10 }}
              />
            )}
            <br />
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
          >
            {loading ? (
              <Grid
                container
                spacing={0}
                alignItems="center"
                justify="center"
                style={{ minHeight: "5vh" }}
              >
                <CircularProgress />
              </Grid>
            ) : (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
              >
                <Button
                  onClick={handleProfileModal}
                  variant="contained"
                  // color="danger"
                >
                  {t("cancel")}
                </Button>
                <Button
                  onClick={handleSetProfileModal}
                  variant="contained"
                  color="secondary"
                  style={{ marginLeft: 10 }}
                >
                  {t("save")}
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Modal>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
    </div>
  );
}


const validationSchema = yup.object().shape({
  firstName: yup.string().required("First Name is required"),
  lastName: yup.string().required("Last Name is required"),
  mobile: yup.string().required("Mobile is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  // licenseImage: yup.string().required("License Image is required"),
  // licenseImageBack: yup.string().required("License Image Back is required"),
  // verifyId: yup.string().required("ID/Passport Number is required"),
  // verifyImage: yup.string().required("ID/Passport Image is required"),
});

function AddRowModal({
  isOpen,
  onClose,
  onAddRow,
  editing,
  oldData,
  setediting,
  hadnleUpdateRow,
  setOlddata,
  uploadImage,
  updateLicenseImage,
  dispatch,
  fetchUsersOnce,
  setloader,
  redirectMe
}) {
  const [firstName, setfirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [mobile, setmobile] = useState("");
  const [email, setmail] = useState("");
  const [approved, setapproved] = useState(false);
  const [driverActiveStatus, setDriverStatus] = useState(false);
  const [licenseImage, setlicenseImage] = useState("");
  const [licenseImageBack, setlicenseImageBack] = useState("");
  const [verifyId, setverifyId] = useState("");
  const [verifyImage, setverifyImage] = useState("");
  const [walletBalance, setwalletBalance] = useState(0);
  const [queue, setqueue] = useState(false);
  const [errors, setErrors] = useState({});
  const [frontimg, setimg] = useState("");
  const [backimg, setbackImg] = useState("");
  const [frontBlob, setfrontBlob] = useState("");
  const [backBlob, setbackBlob] = useState("");
  const [firstImageType, setfirstImgType] = useState("");
  const [backimgType, setbackImgType] = useState("");
  const [frontImage, setfrontImage] = useState("");
  const [backImage, setBackImage] = useState("");

  // const [sendingImage,setsendingImage]
  useEffect(() => {
    if (oldData) {
      setfirstName(oldData?.firstName || "");
      setlastName(oldData?.lastName || "");
      setmobile(oldData?.mobile || "");
      setmail(oldData?.email || "");
      setapproved(oldData?.approved || false);
      setDriverStatus(oldData?.driverActiveStatus || false);
      setimg(oldData?.licenseImage || "");
      setbackImg(oldData?.licenseImageBack || "");
      setverifyId(oldData?.verifyId || "");
      setverifyImage(oldData?.verifyImage || "");
      setwalletBalance(oldData?.walletBalance || 0);
      setqueue(oldData?.queue || false);
    }
  }, [oldData]);
  // useEffect(() => {
  //   runMe();
  // }, [frontBlob, backBlob]);

  // const runMe = async () => {
  //   let frontImage;
  //   let backImage;
  //   if (frontBlob) {
  //     frontImage = await uploadImage(frontBlob);
  //     if (frontImage) setfrontImage(frontImage);
  //   }
  //   if (backBlob) {
  //     backImage = await uploadImage(backBlob);
  //     if (backImage) setBackImage(backImage);
  //   }
  // };
  const validateForm = async () => {
    try {
      await validationSchema.validate(
        { firstName, lastName, mobile, email },
        { abortEarly: false }
      );
      setErrors({});
      return true;
    } catch (validationErrors) {
      const errorsMap = {};
      validationErrors.inner.forEach((error) => {
        errorsMap[error.path] = error.message;
      });
      setErrors(errorsMap);
      return false;
    }
  };
  const handleAddRow = async () => {

    try {
      const isValid = await validateForm();
      if (!isValid) return;
      if (editing) {
        setloader(true);
        if (firstImageType == "licenseImage") {
          dispatch(updateLicenseImage(oldData.id, frontBlob, firstImageType));
        }
        if (backimgType == "licenseImageBack") {
          dispatch(updateLicenseImage(oldData.id, backBlob, backimgType));
        }
        EditUpdate();
        setloader(false);
      } else {
        setloader(true);
        console.log("this works")
        let frontImage;
        let backImage;
        if (frontBlob) {
          frontImage = await uploadImage(frontBlob);
          console.log("this works 2")

        }
        if (backBlob) {
          backImage = await uploadImage(backBlob);
        }
        if (frontImage && backImage) {
          runSubmit(frontImage, backImage);
          setloader(false);
        } else {
          alert("Upload Document Images ");
          setloader(false);

        }
      }
    } catch (error) {
      console.log("erro exists here",error)
      const validationErrors = {};
      error.inner.forEach((err) => {
        validationErrors[err.path] = err.message;
      });
      setErrors(validationErrors);
    }
  };

  const EditUpdate = async (frontImage, backImage) => {
    await validationSchema.validate(
      {
        firstName,
        lastName,
        mobile,
        email,
        // licenseImage,
        // licenseImageBack,
        verifyId,
        // verifyImage,
      },
      { abortEarly: false }
    );
    setErrors({});

    const newRow = {
      firstName,
      lastName,
      mobile,
      email,
      approved,
      driverActiveStatus,
      // licenseImage: frontImage ? frontImage : frontimg,
      // licenseImageBack: backImage ? backImage : backImage,
      verifyId,
      // verifyImage,
      walletBalance,
      queue,
    };

    let oldObjectKeys = Object.keys(oldData);
    let newObjectkeys = Object.keys(newRow);
    let commonKeys = getCommonElements(oldObjectKeys, newObjectkeys);
    commonKeys.forEach((val) => {
      delete oldData[val];
    });

    const latestObj = { ...oldData, ...newRow };
    if (editing) {
      hadnleUpdateRow(latestObj, oldData);
    } else {
      onAddRow(latestObj);
    }
    setediting(false);
    setimg("");
    setbackImg("");
    handleClose();
  };
  const runSubmit = async (frontImage, backImage) => {
    await validationSchema.validate(
      {
        firstName,
        lastName,
        mobile,
        email,
        licenseImage,
        licenseImageBack,
        verifyId,
        verifyImage,
      },
      { abortEarly: false }
    );
    setErrors({});

    const newRow = {
      firstName,
      lastName,
      mobile,
      email,
      approved,
      driverActiveStatus,
      licenseImage: frontImage ? frontImage : frontimg,
      licenseImageBack: backImage ? backImage : backImage,
      verifyId,
      verifyImage,
      walletBalance,
      queue,
    };

    let oldObjectKeys = Object.keys(oldData);
    let newObjectkeys = Object.keys(newRow);
    let commonKeys = getCommonElements(oldObjectKeys, newObjectkeys);
    commonKeys.forEach((val) => {
      delete oldData[val];
    });

    const latestObj = { ...oldData, ...newRow };
    if (editing) {
      hadnleUpdateRow(latestObj, oldData);
    } else {
      onAddRow(latestObj);
      redirectMe()
    }
    setediting(false);
    setimg("");
    setbackImg("");
    handleClose();
  };
  const handleClose = () => {
    setfirstName("");
    setlastName("");
    setmobile("");
    setmail("");
    setapproved(false);
    setDriverStatus(false);
    setimg("");
    setbackImg("");

    setverifyId("");
    setverifyImage("");
    setwalletBalance("");
    setqueue("");
    setErrors("");
    setediting(false);
    setOlddata("");
    onClose();
  };

  function getCommonElements(array1, array2) {
    return array1.filter((element) => array2.includes(element));
  }

  const changeType = (rowData, text) => {
    if (text === "licenseImage") {
      setfirstImgType(text);
    } else if (text === "licenseImageBack") {
      setbackImgType(text);
    }
  };
  return (
    <Modal open={isOpen} onClose={onClose}>
      <div
        style={{
          backgroundColor: "white",
          width: "80%",
          margin: "auto",
          marginTop: "3vh",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflow: "scroll",
          maxHeight: "90vh", // Add max height for scrolling
          scrollbarWidth: "thin", // Width of the scrollbar
          scrollbarColor: "#888 #f1f1f1", // Color of the scrollbar thumb and track
        }}
      >
        <h2 style={{ marginLeft: 10 }}>{editing ? "Edit" : "Add"} Driver</h2>
        <TextField
          label="First Name"
          value={firstName}
          onChange={(e) => setfirstName(e.target.value)}
          error={errors.firstName !== undefined}
          helperText={errors.firstName}
          style={{ width: "100%", marginBottom: "10px" }}
        />
        <TextField
          label="Last Name"
          value={lastName}
          onChange={(e) => setlastName(e.target.value)}
          error={errors.lastName !== undefined}
          helperText={errors.lastName}
          style={{ width: "100%", marginBottom: "10px" }}
        />
        {/* <div style={{ flexDirection: "row" }}></div> */}
        <TextField
          label="Mobile"
          value={mobile}
          placeholder="+15555551234"
          onChange={(e) => setmobile(e.target.value)}
          error={errors.mobile !== undefined}
          helperText={errors.mobile}
          style={{ width: "100%", marginBottom: "10px" }}
        />
        <TextField
          label="Email"
          value={email}
          onChange={(e) => setmail(e.target.value)}
          error={errors.email !== undefined}
          helperText={errors.email}
          style={{ width: "100%", marginBottom: "10px" }}
        />
        {/* <TextField
          label="License Image"
          type="file"
          value={licenseImage}
          onChange={(e) => setlicenseImage(e.target.value)}
          error={errors.licenseImage !== undefined}
          helperText={errors.licenseImage}
          style={{ width: "100%", marginBottom: "10px" }}
        />
        <TextField
          label="License Image Back"
          type="file"
          value={licenseImageBack}
          onChange={(e) => setlicenseImageBack(e.target.value)}
          error={errors.licenseImageBack !== undefined}
          helperText={errors.licenseImageBack}
          style={{ width: "100%", marginBottom: "10px" }}
        /> */}
        {/* <TextField
          label="ID/Passport Number"
          value={verifyId}
          onChange={(e) => setverifyId(e.target.value)}
          error={errors.verifyId !== undefined}
          helperText={errors.verifyId}
          style={{ width: "100%", marginBottom: "10px" }}
        /> */}
        {/* <TextField
          label="ID/Passport Image"
          value={verifyImage}
          onChange={(e) => setverifyImage(e.target.value)}
          error={errors.verifyImage !== undefined}
          helperText={errors.verifyImage}
          style={{ width: "100%", marginBottom: "10px" }}
        /> */}

        {/* URL.createObjectURL() */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            paddingLeft: 3,
            gap: 5,
          }}
        >
          <div
            style={{ width: "100%", display: "flex", flexDirection: "column" }}
          >
            <label
              htmlFor="licenseFront"
              style={{
                color: "gray",
                fontSize: 13,
                marginBottom: 10,
                marginLeft: 10,
              }}
            >
              License Image - Front
            </label>
            <input
              accept="image"
              type="file"
              id="licenseFront"
              style={{
                padding: 10,
                // border: "1px solid gray",
                color: "gray",
                borderRadius: 12,
                opacity: 0.4,
              }}
              onChange={(e) => {
                setfrontBlob(e.target.files[0]);
                changeType(e.target.files[0], "licenseImage");
                setimg(URL.createObjectURL(e.target.files[0]));
              }}
            />
          </div>

          {frontimg ? (
            <img
              src={frontimg}
              onClick={() => setimg("")}
              style={{
                width: 100,
                height: 110,
                border: "1px solid gray",
                borderRadius: 12,
              }}
              alt="frontimg"
            />
          ) : null}

          {/* backimg */}
          <div
            style={{ width: "100%", display: "flex", flexDirection: "column" }}
          >
            <label
              htmlFor="licenseBack"
              style={{
                color: "gray",
                fontSize: 13,
                marginBottom: 10,
                marginLeft: 10,
              }}
            >
              License Image - Back
            </label>
            <input
              type="file"
              id="licenseBack"
              style={{
                padding: 10,
                // border: "1px solid gray",
                color: "gray",
                borderRadius: 12,
                opacity: 0.4,
              }}
              onChange={(e) => {
                setbackBlob(e.target.files[0]);
                changeType(e.target.files[0], "licenseImageBack");
                setbackImg(URL.createObjectURL(e.target.files[0]));
              }}
            />
          </div>
          {backimg ? (
            <img
              src={backimg}
              alt="backimg"
              onClick={() => setbackImg("")}
              style={{
                width: 100,
                height: 110,
                border: "1px solid gray",
                borderRadius: 12,
              }}
            />
          ) : null}
        </div>
        {/* <div
          style={{ display: "flex", width: "100%", margin: 10, gap: 20 }}
        ></div> */}
        <div
          style={{
            marginLeft: 55,
            display: "flex",
            flexDirection: "row",
            gap: 50,
            width: "100%",
          }}
        >
          <div>
            <label htmlFor="check" style={{ color: "gray", fontSize: 14 }}>
              Drive Active Status
            </label>
            <Checkbox
              id="check"
              checked={driverActiveStatus}
              style={{ borderWidth: 0 }}
              onChange={(e) => setDriverStatus(e.target.checked)}
            />
          </div>
          <div>
            <label htmlFor="approved" style={{ color: "gray", fontSize: 14 }}>
              Account Approved
            </label>
            <Checkbox
              id="approved"
              checked={approved}
              style={{ borderWidth: 0 }}
              onChange={(e) => setapproved(e.target.checked)}
            />
          </div>
          <div>
            <label htmlFor="Busy" style={{ color: "gray", fontSize: 14 }}>
              Busy
            </label>
            <Checkbox
              id="Busy"
              checked={queue}
              style={{ borderWidth: 0 }}
              onChange={(e) => setqueue(e.target.checked)}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            gap: 10,
            marginTop: 20,
          }}
        >
          <Button
            variant="contained"
            color="secondary"
            style={{ backgroundColor: "darkblue", color: "white" }}
            onClick={handleAddRow}
          >
            {editing ? "Update" : "Add"}
          </Button>
          <Button
            variant="contained"
            color="secondary"
            style={{
              backgroundColor: "darkblue",
              color: "white",
              marginLeft: "10px",
            }}
            onClick={handleClose}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
}
